module.exports = __webpack_public_path__ + "img/sichuan.6d599c3f.jpg";